var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_svg__check_svg__Canvas",
    transform: "translate(3609 -2453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_svg__check_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#check_svg__check_svg__path0_fill",
    transform: "translate(-3608.01 2453.49)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "check_svg__check_svg__path0_fill",
    d: "M 38.2344 0.394665C 37.6508 -0.15416 36.7344 -0.127335 36.1849 0.45484L 14.9119 23.0176L 2.36361 12.8335C 1.74228 12.3289 0.82878 12.4246 0.32418 13.0452C -0.18042 13.6665 -0.0854454 14.58 0.53588 15.0846L 14.1296 26.1169C 14.3979 26.3344 14.7205 26.441 15.0431 26.441C 15.4296 26.441 15.8145 26.2873 16.0987 25.9857L 38.2946 2.44352C 38.8442 1.86134 38.8173 0.944215 38.2344 0.394665Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e0ef15775a2f44a65564fa4f4bc3967f.svg";
export { ForwardRef as ReactComponent };